import { AlertService } from './alert.service';
import { Injectable } from '@angular/core';
import { WSService } from './ws.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ConcurrentLimitMonitorService {

  constructor(ws: WSService, private translate: TranslateService, private alert: AlertService) {
    var visible = false;
    ws.observe('concurrentLimitReached').subscribe((data) => {
      const dialogOptions = data.data.maxCount === 0
        ? {
          type: 'warning' as const,
          title: this.translate.instant('accessDenied'),
          text: this.translate.instant('accessNotActivated'),
          confirmButtonText: this.translate.instant('ok')
        }
        : (() => {
          const message = this.translate.instant('maxConnectionsReached');
          return {
            type: 'warning' as const,
            title: message,
            text: message,
            confirmButtonText: this.translate.instant('ok')
          };
        })();

      if (visible) {
        return;
      }

      visible = true;
      // Posle OK refresh stranice — server je već skinuo sesiju (RemoveSession + WSConcurrentLimitReached),
      // pa novi load mora da pokuša ponovno auth/limit gate; ako i dalje preko limita, server će ponovo
      // poslati istu poruku.
      this.alert.open(dialogOptions).then(() => {
        visible = false;

        window.location.reload();
      });
    });
  }

}
